export const $productTickboxes = ($availableProducts, tickboxesFactory) => {
  const productTickboxes = tickboxesFactory(
    $availableProducts.items,
    "product_id"
  );
  return productTickboxes;
};

$productTickboxes.$inject = ["$availableProducts", "tickboxesFactory"];
